<template>
  <div class="flex items-start justify-between py-2">
    <div
      :class="{
        'flex flex-row items-center': !isMobile,
        'flex flex-col': isMobile,
      }"
    >
      <Headline
        class="text-xl font-normal sm:text-2xl"
        tag="h1"
        :is-uppercase="false"
      >
        {{ title || $t('basket.heading') }}
      </Headline>
      <div
        :class="{
          'ml-2 text-xl': !isMobile,
          'text-sm text-gray-secondary': isMobile,
        }"
      >
        ({{ basketCount }} {{ $t('basket.products_count', basketCount) }})
      </div>
    </div>
    <NuxtLink
      v-if="isMobile && backLink"
      :to="backLink"
      class="leading-0 flex items-center gap-2 bg-platin px-3 py-2 text-base"
    >
      <Icon icon="arrow-left" size="4" />
      <span>{{ $t('basket.continue_shopping_label') }}</span>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { useSessionStorage } from '@vueuse/core'
import { useDeviceType } from '~/composables/useDeviceType'
import useRouteHelpers from '#layers/base/composables/useRouteHelpers'

defineProps<{ title?: string; basketCount: number }>()

const { isMobile } = useDeviceType()

const { toLocalePath } = useRouteHelpers()

const lastPlp = useSessionStorage('last-plp', toLocalePath('/'))

const backLink = computed(() => lastPlp.value || toLocalePath('/'))
</script>
